window.LM = window.LM || {};
window.LM.cart = {
  get dialog() { return document.querySelector('[data-lm-cart-dialog]'); },
  codes: [], busy: false,
  async refresh() {
    const url = new URL(window.routes.cart_url, location.origin);
    url.searchParams.set('section_id', 'lm-cart-drawer');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw new Error('Could not load your bag. Please use View cart.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = doc.querySelector('[data-lm-cart-render]');
    if (!content) throw new Error('Could not load your bag. Please use View cart.');
    this.dialog.querySelector('[data-lm-cart-content]').replaceChildren(content);
    const cartResponse = await fetch(window.routes.cart_url + '.js', {cache:'no-store'});
    if (cartResponse.ok) { const cart = await cartResponse.json(); this.codes = (cart.discount_codes || []).filter(c=>c.applicable).map(c=>c.code); }
  },
  async open() {
    const dialog = this.dialog;
    if (!dialog) { location.assign(window.routes.cart_url); return; }
    this.opener = document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('lm-modal-open');
    dialog.querySelector('[data-lm-cart-close]').focus();
    const status = dialog.querySelector('[data-lm-cart-status]'); status.textContent = 'Loading your bag…';
    try { await this.refresh(); status.textContent = ''; }
    catch(error) { status.textContent = error.message; const link = document.createElement('a'); link.href = window.routes.cart_url; link.textContent = 'View cart'; dialog.querySelector('[data-lm-cart-content]').replaceChildren(link); }
  },
  async update(endpoint, data, message, code) {
    if (this.busy) return;
    this.busy = true;
    const content = this.dialog.querySelector('[data-lm-cart-content]'); content.setAttribute('aria-busy','true');
    const status = this.dialog.querySelector('[data-lm-cart-status]'); status.textContent = 'Updating your bag…';
    try {
      const response = await fetch(window.routes.cart_url + '/' + endpoint + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)});
      const cart = await response.json(); if (!response.ok) throw new Error(cart.description || 'Could not update your bag. Please try again.');
      const applicable = code ? (cart.discount_codes || []).some(c=>c.code.toLowerCase() === code.toLowerCase() && c.applicable) : true;
      await this.refresh(); document.dispatchEvent(new CustomEvent('cart:updated'));
      status.textContent = applicable ? message : 'That code is not applicable to this bag. Check the code and its requirements.';
    } catch(error) { status.textContent = error.message || 'Could not update your bag. Please try again.'; }
    finally { content.removeAttribute('aria-busy'); this.busy = false; }
  }
};
document.addEventListener('click', event => {
  const cartLink = event.target.closest('.lm-nav__right a');
  if (cartLink && new URL(cartLink.href, location.origin).pathname === new URL(window.routes.cart_url, location.origin).pathname && !event.ctrlKey && !event.metaKey) { event.preventDefault(); window.LM.cart.open(); }
  const remove = event.target.closest('[data-lm-cart-remove]');
  if (remove) window.LM.cart.update('change',{id:remove.dataset.key,quantity:0},'Item removed.');
  const removeCode = event.target.closest('[data-lm-discount-remove]');
  if (removeCode) window.LM.cart.update('update',{discount:window.LM.cart.codes.filter(c=>c!==removeCode.dataset.code).join(',')},'Discount removed.');
  if (event.target.closest('[data-lm-cart-close]')) window.LM.cart.dialog.close();
  if (event.target === window.LM.cart.dialog) window.LM.cart.dialog.close();
});
document.addEventListener('change', event => {
  if (event.target.matches('[data-lm-cart-quantity]') && event.target.reportValidity()) window.LM.cart.update('change',{id:event.target.dataset.key,quantity:Number(event.target.value)},'Quantity updated.');
});
document.addEventListener('submit', event => {
  if (event.target.matches('[data-lm-cart-quantity-form]')) {
    event.preventDefault(); const data = new FormData(event.target);
    window.LM.cart.update('change',{id:data.get('id'),quantity:Number(data.get('quantity'))},'Quantity updated.'); return;
  }
  if (!event.target.matches('[data-lm-discount-form]')) return;
  event.preventDefault(); const code = new FormData(event.target).get('discount').trim();
  if (code) window.LM.cart.update('update',{discount:[...new Set([...window.LM.cart.codes,code])].join(',')},'Discount applied.',code);
});
document.querySelector('[data-lm-cart-dialog]')?.addEventListener('close',()=>{document.documentElement.classList.remove('lm-modal-open');window.LM.cart.opener?.focus({preventScroll:true});});
// Desktop filter panels start open; mobile panels start closed and retain the shopper's toggles.
const lmFilterViewport = matchMedia('(max-width:680px)');
function lmFilterLayout() { document.querySelectorAll('[data-lm-filter-shell]').forEach(el=>{el.open=!lmFilterViewport.matches;}); }
lmFilterLayout(); lmFilterViewport.addEventListener('change',lmFilterLayout);
document.addEventListener('shopify:section:load',lmFilterLayout);
